import { render, staticRenderFns } from "./LiqPayTermsAndConditions.vue?vue&type=template&id=63f16272"
import script from "./LiqPayTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./LiqPayTermsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports